import { render, staticRenderFns } from "./WarningHistory.vue?vue&type=template&id=721ff460&scoped=true&"
import script from "./WarningHistory.vue?vue&type=script&lang=js&"
export * from "./WarningHistory.vue?vue&type=script&lang=js&"
import style0 from "./WarningHistory.vue?vue&type=style&index=0&id=721ff460&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721ff460",
  null
  
)

export default component.exports